import { useSelectSystemModeStore } from 'src/hooks/stores'

export const useSelectSystemMode = () => {
  const { selectSystemModeStoreValue, setSelectSystemModeStoreValue } = useSelectSystemModeStore()

  const isGeneralContractorOrderMode = selectSystemModeStoreValue.mode === 'GeneralContractorOrder'

  const updateMode = (mode: 'normal' | 'GeneralContractorOrder') => {
    setSelectSystemModeStoreValue({ mode })
  }

  return {
    isGeneralContractorOrderMode,
    updateMode,
  }
}
